import { Outlet } from "react-router-dom";
import HorizontalNav from "./HorizontalNav";

const ReportRouteLayout = () => {
    return(
        <>
            <HorizontalNav />
            <Outlet/>
        </>
    )
}

export default ReportRouteLayout;